import {DVIREntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {DVIRAction} from "./DVIRActionMenu";
import {useDVIRMutation} from "../../../hooks/useDVIRMutation";
import { useApp } from "../../../providers/RegionProvider/RegionProvider";
import {useDownloadDVIR} from "../../../hooks/useDownloadDVIR";

export type UseDVIRActionProps = {}

export type UseDVIRActionResult = {
  onDVIRActionClick: (dvir: DVIREntity, action: DVIRAction) => void;
}

export const useDVIRAction = (props: UseDVIRActionProps = {}): UseDVIRActionResult => {
  const {} = props

  const { baseQueryApi } = useApp()
  const navigate = useNavigate();

  const {
    deleteDVIR,
  } = useDVIRMutation()

  const {
    downloadDVIR,
  } = useDownloadDVIR({baseQueryApi})

  const _onDVIRActionClick = useCallback((dvir: DVIREntity, action: DVIRAction) => {
    if (action === "EDIT") {
      navigate(`/dvirs/form`, {state: {id: dvir.id}})
    } else if (action === "MECHANIC_REVIEW") {
      navigate(`/dvirs/mechanic-review`, {state: {id: dvir.id}})
    } else if (action === "DELETE") {
      deleteDVIR(dvir.id, undefined)
    } else if (action === "DOWNLOAD") {
      downloadDVIR(dvir.id)
    }
  }, [navigate, deleteDVIR, downloadDVIR])

  return {
    onDVIRActionClick: _onDVIRActionClick
  }
}
